import React from 'react';
import * as S from './styles';
import { SpacerProps } from './types';

function ForwardedSpacer<As extends React.ElementType = 'div'>(
  {
    as,
    align = 'start',
    children,
    justify = 'start',
    orientation = 'horizontal',
    space = 'small',
    ...props
  }: SpacerProps<As>,
  ref: React.ForwardedRef<React.ElementRef<As>>,
): React.ReactElement | null {
  const Component: React.ElementType = as ?? 'div';

  return (
    <S.Root
      $align={align}
      as={Component}
      $justify={justify}
      $orientation={orientation}
      $space={space}
      ref={ref}
      {...props}
    >
      {children}
    </S.Root>
  );
}

/**
 * A component that implements flexbox
 */
export const Spacer = React.forwardRef(ForwardedSpacer) as <
  As extends React.ElementType = 'div',
>(
  props: SpacerProps<As> & { ref?: React.Ref<React.ElementRef<As>> },
) => React.ReactElement | null;

export default Spacer;
